import {
    QueryKey,
    useQuery,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';
import {
    getDataPostProcessingMiddleware,
    getDataPreProcessingUrlMiddleware,
} from 'routes/BudgetModule/shared/getDataMiddlewares';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

export const useCustomGetData = (
    endpoint: string,
    queryKey: QueryKey,
    options: Pick<UseQueryOptions, 'enabled'> = {},
): UseQueryResult<GetDataResponse, HttpError> =>
    useQuery<GetDataResponse, HttpError>({
        queryKey,
        queryFn: async () => {
            const response = await RQAPICallWithData<GetDataResponse>({
                endpoint,
                method: 'GET',
                preProcessingUrlCallback: getDataPreProcessingUrlMiddleware,
                postProcessingCallback: getDataPostProcessingMiddleware,
            });
            return response.content.data;
        },
        ...options,
    });
